module.exports = __webpack_public_path__ + "static/media/ttl-1.4fb1d25b.svg";